%YAML 1.1
%TAG !u! tag:unity3d.com,2011:
--- !u!114 &11400000
MonoBehaviour:
  m_ObjectHideFlags: 0
  m_CorrespondingSourceObject: {fileID: 0}
  m_PrefabInstance: {fileID: 0}
  m_PrefabAsset: {fileID: 0}
  m_GameObject: {fileID: 0}
  m_Enabled: 1
  m_EditorHideFlags: 0
  m_Script: {fileID: 11500000, guid: 85449c2ea301fc54091646f096d9e4dc, type: 3}
  m_Name: PoisonInsectBite2
  m_EditorClassIdentifier: 
  impactPrefab: {fileID: 0}
  handGlowPrefab: {fileID: 0}
  handGlowScale: 0.2
  castAuraPrefab: {fileID: 0}
  castAuraScale: 0.4
  castAuraYOffset: 0.5
  attachCastAuraToCaster: 0
  playOnCast: []
  castSound: {fileID: 0}
  castSoundVolume: 0.2
  soundBeforeChannel: {fileID: 8300000, guid: 96c549165c725b94f9b5fa3eeb7d2537, type: 3}
  beforeChannelSoundDelay: 0
  beforeChannelSoundVolume: 0.4
  soundAfterChannel: {fileID: 0}
  afterChannelSoundDelay: 0
  afterChannelSoundVolume: 1
  animation: 16
  animationVariation: 3
  castDelay: 300
  animationSpeed: 1
  animationDuration: 0.5
  skipCooldownOnChannel: 0
  spellName: Bite
  description: Deal damage to the main target.
  icon: {fileID: 2800000, guid: 1ab28e3e1154af9479c46dd1d30ce10e, type: 3}
  usableBy: 1a000000
  cooldown: 8
  castTime: 0
  isCastInterruptible: 0
  channelTime: 0
  isOnGlobalCooldown: 1
  aoeRadius: 0
  isHidden: 0
  isInternal: 0
  isRegional: 0
  preventManualCasts: 1
  useKeyboardForFacing: 0
  spellType: {fileID: 11400000, guid: cac5c20beb8c65d47b88d3b03bc2946d, type: 2}
  spellKey: 100095
  alwaysCastableSpell: 0
  luaScript: {fileID: 4900000, guid: 718823ad25bba394ba78f3ae5f6f29b8, type: 3}
